// Upload cap chosen per machine; the transport budget never goes above it.

export type UploadLimit = 'none' | '8' | '5' | '3' | '2' | '1'

export const UPLOAD_LIMITS: Record<UploadLimit, { label: string; description: string; bitrate: number }> = {
    none: { label: 'Sem limite', description: 'So o teto da qualidade escolhida', bitrate: 0 },
    8: { label: '8 Mbps', description: 'Internet boa, sobra pro resto', bitrate: 8_000_000 },
    5: { label: '5 Mbps', description: 'Da pra 1080p', bitrate: 5_000_000 },
    3: { label: '3 Mbps', description: 'Da pra 720p', bitrate: 3_000_000 },
    2: { label: '2 Mbps', description: 'Internet fraca; 720p com menos nitidez', bitrate: 2_000_000 },
    1: { label: '1 Mbps', description: 'O minimo; prefira 540p', bitrate: 1_000_000 }
}

export const UPLOAD_LIMIT_ORDER: UploadLimit[] = ['none', '8', '5', '3', '2', '1']

const UPLOAD_LIMIT_KEY = 'screen-share:upload-limit'

export function loadUploadLimit(): UploadLimit {
    try {
        const saved = localStorage.getItem(UPLOAD_LIMIT_KEY)
        return saved && saved in UPLOAD_LIMITS ? saved as UploadLimit : 'none'
    } catch {
        return 'none'
    }
}

export function saveUploadLimit(limit: UploadLimit): void {
    try {
        localStorage.setItem(UPLOAD_LIMIT_KEY, limit)
    } catch {
        // Private window: the choice just lasts for this visit.
    }
}

/** The stricter of the quality budget and the user's cap. */
export function cappedBudget(budget: number, limit: UploadLimit): number {
    const cap = UPLOAD_LIMITS[limit].bitrate
    if (cap <= 0) return budget
    return budget > 0 ? Math.min(budget, cap) : cap
}
